import { Link } from "react-router-dom"
import styled from "styled-components"

const NotFoundWrap = styled.div`
   display: flex;
   justify-content: center;
   align-items: center;
   height: 90vh;
   .txt_wrap {
      text-align: center;
   }
   .txt_wrap .tit {
      font-size: 48px;
      line-height: 60px;
      margin-bottom: 24px;
   }
   .txt_wrap .txt{
      line-height: 32px;
      font-size: 22px;
      margin-bottom: 48px;
   }
   .txt_wrap .btn-home {
      width: fit-content;
      border-radius: 9999px;
      padding: 12px 36px;
      margin-left: auto;
      margin-right: auto;
      color: #fff;
      background-color: #212121;
   }
   @media screen and (max-width:1280px){
      .txt_wrap .tit{
         font-size: 22px;
         margin-bottom: 8px;
      }
      .txt_wrap .txt{
         line-height: 22px;
         font-size: 12px;
         margin-bottom: 32px;
      }
   }
`

export default function NotFound() {

   return (
      <NotFoundWrap>
         <div className="notfound">
            <div className="txt_wrap">
               <h2 className="tit">
                  페이지를 찾을 수 없어요
               </h2>
               <p className="txt">
                  방문하시려는 주소가 잘못되었거나,<br />
                  페이지가 변경 또는 삭제된 것 같아요.
               </p>
               <Link to="/" className="btn-home">홈으로</Link>
            </div>
         </div>
      </NotFoundWrap>
   )
}
